import React from 'react';

import ButtonDropdown from 'components/ButtonDropdown';

import './styles.css';

class MainContent extends React.Component<any> {
  render() {
    return (
      <div style={{width: 400, margin: 200}}>
        <ButtonDropdown>
          <ButtonDropdown.Option>1</ButtonDropdown.Option>
          <ButtonDropdown.Option>2</ButtonDropdown.Option>
          <ButtonDropdown.Option>3</ButtonDropdown.Option>
          <ButtonDropdown.Option>4</ButtonDropdown.Option>
        </ButtonDropdown>
      </div>
    );
  }
}

export default MainContent;
